import { API_BASE } from './config'
import { getAuthHeaders } from './api'

export interface AppNotification {
  id: number
  type: string
  payload: Record<string, unknown>
  read_at: string | null
  created_at: string
}

export interface NotificationList {
  notifications: AppNotification[]
  total: number
  unread: number
}

interface RequestInit {
  method?: string
  body?: string
}

async function call<T>(path: string, init?: RequestInit): Promise<T> {
  const response = await fetch(`${API_BASE}${path}`, {
    method: init?.method,
    body: init?.body,
    headers: {
      ...getAuthHeaders(),
      ...(init?.body ? { 'Content-Type': 'application/json' } : {})
    }
  })
  const result = await response.json().catch(() => null) as { success: boolean; data?: T; error?: { message?: string } } | null
  if (!response.ok || !result?.success || result.data === undefined) {
    throw new Error(result?.error?.message || 'Bildirimler yüklenemedi.')
  }
  return result.data
}

export const notificationService = {
  fetch: (limit = 20): Promise<NotificationList> =>
    call(`/users/me/notifications?limit=${limit}`),

  unreadCount: (): Promise<{ unread: number }> =>
    call('/users/me/notifications/unread-count'),

  markAllRead: (): Promise<{ updated: number }> =>
    call('/users/me/notifications/read', {
      method: 'POST',
      body: JSON.stringify({ all: true })
    }),

  markRead: (ids: number[]): Promise<{ updated: number }> =>
    call('/users/me/notifications/read', {
      method: 'POST',
      body: JSON.stringify({ ids })
    })
}
